import { AnyAction } from 'redux';
import { SagaIterator } from 'redux-saga';
import { call, put, takeLatest } from 'redux-saga/effects';
import { getConfirmations } from 'src/api/confirmations';
import { enqueueSnackbarAction } from '../notifications/actions';
import {
    FETCH_CONFIRMATIONS,
    requestFetchConfirmations,
    requestFetchConfirmationsFailure,
    requestFetchConfirmationsSuccess,
} from './actions';

function* fetchConfirmationsSaga(action: AnyAction): SagaIterator {
    yield put(requestFetchConfirmations());

    const { error, response } = yield call(getConfirmations);

    if (error) {
        yield put(
            enqueueSnackbarAction({
                message: 'Fehler: Bestätigungen konnten nicht geladen werden!' + error.message,
                options: {
                    key: new Date().getTime() + Math.random(),
                    variant: 'error',
                },
            })
        );
        yield put(requestFetchConfirmationsFailure(error));
    } else {
        // yield put(
        //     enqueueSnackbarAction({
        //         message: response.statusText || 'Bestätigungen erfolgreich geladen',
        //         options: {
        //             key: new Date().getTime() + Math.random(),
        //             variant: 'success',
        //         },
        //     })
        // );
        yield put(requestFetchConfirmationsSuccess(response));
    }
}

export function* generateFetchConfirmationsWatcher() {
    yield takeLatest(FETCH_CONFIRMATIONS, fetchConfirmationsSaga);
}
